import { createSelector } from 'reselect';
import { IAppState } from 'spw-redux/reducer';

export const selectCurrentOrganization = (state: IAppState) =>
  state.organizationsReducer.currentOrganization;

export const currentOrganizationUsers = (state: IAppState) =>
  state.organizationsReducer.currentOrganizationUsers;

export const billingPeriods = (state: IAppState) =>
  state.organizationsReducer.billingPeriods;

export const selectOrgHasAccessToAITools = createSelector(
  selectCurrentOrganization,
  (org) => org?.hasAccessToAITools
);
